<template>
    <b-container>
        <h1>Users</h1>
        <b-spinner v-if="loading"></b-spinner>
        <template v-else>
            <b-form-input v-model="filterTerm" placeholder="Filter..." style="margin-bottom: 10px"></b-form-input>
            <user-table
                    :users="filteredUsers"
                @userRowClicked="showUserModal"
            ></user-table>
            <b-modal v-model="modalOpened" :title="selectedUser && selectedUser.name">
                <user-todo-list v-if="selectedUser" :selected-user-id="selectedUser.id"></user-todo-list>
            </b-modal>
        </template>
    </b-container>
</template>

<script>
    import axios from 'axios'
    import urls from '@/api/urls'
    import UserTable from "@/components/UserTable";
    import UserTodoList from "@/components/UsersTodoList";

    export default {
        name: "UsersList",
        components: {UserTodoList, UserTable},
        methods: {
            loadUsers() {
                axios.get(urls.USERS_URL).then(response => {
                    this.users = response.data;
                }).catch(err => {
                    alert(err);
                }).finally(() => {
                    this.loading = false;
                })
            },
            showUserModal(user) {
                this.selectedUser = user;
                this.modalOpened = true;
            }
        },
        computed: {
          filteredUsers() {
              let filteredFields = ['name', 'email', 'username'];
              let filter = this.filterTerm.toLowerCase();

              return this.users.filter(function (user) {

                  function fieldMatch(fieldName) {
                      return user[fieldName].toLowerCase().includes(filter)
                  }
                  return !filter || filteredFields.some(fieldMatch)
              })
          }
        },
        mounted() {
            this.loadUsers()
        },
        data() {
            return {
                loading: true,
                users: null,
                filterTerm: '',
                selectedUser: null,
                modalOpened: false
            }
        }
    }
</script>

<style scoped>


</style>
